module.exports = __webpack_public_path__ + "static/media/intro_mob_png_happy.59f7f835.gif";